/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Unignore16(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Unignore16',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"m12.468 10.694-.773-1.159a3.2 3.2 0 0 1-.545-1.77V6.75c0-1.281-.95-2.365-2.25-2.714V3.31c0-.447-.404-.81-.9-.81-.497 0-.9.363-.9.81v.726c-1.3.35-2.25 1.433-2.25 2.714v1.015c0 .623-.189 1.235-.545 1.77l-.773 1.158a.19.19 0 0 0-.003.204.23.23 0 0 0 .196.103h8.55c.081 0 .156-.04.196-.102a.19.19 0 0 0-.003-.204M6 12c.358.883 1.117 1.5 2 1.5s1.642-.617 2-1.5z","fill":"currentColor"}))
}
